import { Badge } from "@/components/ui/badge";
import {
  Dialog, DialogContent, DialogTrigger,
} from "@/components/ui/dialog";
import { ZoomIn } from "lucide-react";
import { useLocalized } from "@/hooks/useLocalized";

const GalleryItem = ({ item, idx, onSelect }) => {
  const { l } = useLocalized();

  return (
    <Dialog>
      <DialogTrigger asChild>
        <div
          className="gallery-item group cursor-pointer"
          data-testid={`gallery-item-${idx}`}
          onClick={() => onSelect(item)}
        >
          <div className="relative overflow-hidden rounded-xl">
            <img
              src={item.image_url}
              alt={item.title}
              className="w-full h-auto object-cover transition-transform duration-500 group-hover:scale-110"
              loading="lazy"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-[#3D405B]/80 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300">
              <div className="absolute bottom-0 left-0 right-0 p-4">
                <Badge className="bg-[#F2CC8F]/90 text-[#3D405B] mb-2">
                  {item.event_type}
                </Badge>
                <h3 className="text-white font-semibold text-lg">
                  {l(item, "title")}
                </h3>
                {l(item, "description") && (
                  <p className="text-white/80 text-sm mt-1 line-clamp-2">
                    {l(item, "description")}
                  </p>
                )}
              </div>
              <div className="absolute top-4 right-4">
                <div className="w-10 h-10 bg-white/20 backdrop-blur rounded-full flex items-center justify-center">
                  <ZoomIn className="w-5 h-5 text-white" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </DialogTrigger>
      <DialogContent className="max-w-4xl p-0 bg-transparent border-0">
        <div className="sr-only">
          <h2>{item.title}</h2>
        </div>
        <div className="relative">
          <img
            src={item.image_url}
            alt={item.title}
            className="w-full h-auto rounded-xl"
          />
          <div className="absolute bottom-0 left-0 right-0 p-6 bg-gradient-to-t from-black/80 to-transparent rounded-b-xl">
            <Badge className="bg-[#F2CC8F] text-[#3D405B] mb-2">
              {item.event_type}
            </Badge>
            <h3 className="text-white font-bold text-2xl font-['Playfair_Display']">
              {l(item, "title")}
            </h3>
            {l(item, "description") && (
              <p className="text-white/80 mt-2">{l(item, "description")}</p>
            )}
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default GalleryItem;
